import { render, staticRenderFns } from "./ItemChat.vue?vue&type=template&id=74d3d04e&scoped=true&"
import script from "./ItemChat.vue?vue&type=script&lang=js&"
export * from "./ItemChat.vue?vue&type=script&lang=js&"
import style0 from "./ItemChat.vue?vue&type=style&index=0&id=74d3d04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d3d04e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
